import * as styles from "./style.module.scss";
import {graphql, Link, useStaticQuery} from "gatsby";
import React from "react";

import * as classNames from "classnames";
import {StaticImage} from "gatsby-plugin-image";
import {useTrans} from "../../trans";

export const ShortIntro = () => {

    const {trans} = useTrans();

    return (
        <div className={"secondary-wrapper shadow-inset mb-4 pt-4 bg-dark-1"}>
            <div className={"container-sm"}>
                <div className={"row section align-items-center"}>
                    <div className={"col-12 col-md-8 py-4"}>
                        <p className="h2" style={{fontSize: '2rem'}}>{trans({id: 'SHORT_INTRO.HEADER', defaultMessage: "Ich mache digitale Produkte einfach!"})}</p>
                        <p>
                            {trans({id: 'SHORT_INTRO.SUB_HEADER', defaultMessage: "Als Freiberufler aus München entwerfe ich beeindruckende Webanwendungen und Apps mit Leidenschaft, Erfahrung und geballtem Fachwissen."})}
                            <Link className={classNames("d-block mt-3", styles.more)} to={"/"}>
                                <button className={"btn btn-primary btn-lg"} style={{color: 'black'}}>
                                    {trans({id: 'SHORT_INTRO.CTA', defaultMessage: "Mehr Informationen & Referenzen"})}
                                </button>
                            </Link>
                        </p>
                    </div>
                    <div className={classNames("col-12 col-md-4 order-first order-md-2 d-flex justify-content-center", styles.avatar)}>
                        <div className={"d-flex"}>
                            <StaticImage
                                src={"../../../content/assets/images/avatar-small2.png"}
                                width={500}
                                alt={"profile-picture"} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
